import { fetchSyncToken } from "../api/hooks";

const DEVICE_KEY = "kss.device";

export function deviceId(): string {
  try {
    let d = localStorage.getItem(DEVICE_KEY);
    if (!d) {
      d = crypto.randomUUID();
      localStorage.setItem(DEVICE_KEY, d);
    }
    return d;
  } catch {
    return "unknown";
  }
}

/**
 * Fetch a fresh room token. Called by the sync client's auth provider on every join and rejoin
 * (spec §8.5 step 7), so expired tokens are never reused.
 */
export async function roomToken(room: string, peerId: string): Promise<{ token: string; mode: "read" | "write" }> {
  const t = await fetchSyncToken(room, peerId, deviceId());
  return { token: t.token, mode: t.mode };
}
